/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import React from 'react';

import { ContentModuleModal } from '@molecules';
import { IMAGE_SIZE } from '@api/media/constants';

import BannerForm from '../BannerForm';

import Item from './Item';

const BannerImage = ({ visible, onSubmit, previewImg, hide, onDelete, initialValues = {}, errors }) => {
  const form = React.useRef();

  const handleFinish = React.useCallback(
    (values) => {
      onSubmit(values);
      // eslint-disable-next-line no-unused-expressions
      form.current?.resetFields();
      hide();
    },
    [form, hide, onSubmit],
  );

  const handleCancel = React.useCallback(() => {
    // eslint-disable-next-line no-unused-expressions
    form.current?.resetFields();
    hide();
  }, [hide, form]);

  const handleSubmit = () => {
    // eslint-disable-next-line no-unused-expressions
    form.current?.submit();
  };

  return (
    <ContentModuleModal
      visible={visible}
      title="Promotional banner"
      subtitle="Add an image to use as a promotional banner"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD BANNER'}
      onCancel={handleCancel}
      onSubmit={handleSubmit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <BannerForm
        cropSize={IMAGE_SIZE['600x120']}
        ref={form}
        onFinish={handleFinish}
        initialValues={initialValues}
        hideButton
      />
    </ContentModuleModal>
  );
};

BannerImage.Item = Item;

export default BannerImage;
